import React from "react";

import { useGlobalUIStore } from "@/betby/store/globalUIStore";
import emptyBg from "@/betby/assets/image/empty-bg.png";
import errorIcon from "@/betby/assets/image/error-icon.webp";
import errorIconPoly from "@/betby/assets/image/poly/error-icon.webp";
import { BetbyModalShell } from "./BetbyModalShell";
import { useThemeViewModel } from "@/betby/viewmodels/useThemeViewModel";

export default function NetworkRetryModal() {
  const modal = useGlobalUIStore((s) => s.modal);
  const hideNetworkRetryModal = useGlobalUIStore(
    (s) => s.hideNetworkRetryModal,
  );
  const { theme } = useThemeViewModel();

  const open = modal?.type === "networkRetry";
  const callbacks = open ? modal.callbacks : null;

  const handleConfirm = () => {
    callbacks?.onConfirm?.();
    hideNetworkRetryModal();
  };

  const handleRequestClose = () => {
    callbacks?.onClose?.();
    hideNetworkRetryModal();
  };

  const illustration = (
    <div
      className="flex h-[158px] w-[158px] items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: theme === "sc" ? `url(${emptyBg})` : "none",
      }}
    >
      <img
        src={theme === "sc" ? errorIcon : errorIconPoly}
        alt=""
        width={120}
        height={120}
        className="mx-auto"
      />
    </div>
  );

  return (
    <BetbyModalShell
      open={open}
      zIndexClass="z-[99999]"
      title="No internet"
      illustration={illustration}
      description={
        <p className="text-center font-medium">
          Something wrong with your connection.
          <br />
          Please check and try again.
        </p>
      }
      primaryLabel="Try Again"
      onPrimaryClick={handleConfirm}
      showCloseButton
      onRequestClose={handleRequestClose}
      closeOnBackdrop
    />
  );
}
